import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredInspectionResultss,
  selectInspectionResultsFilterVisible,
  selectInspectionResultsLoading,
} from './store/selectors';
import VirtualList from '../components/VirtualList'; // Import VirtualList
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner'; // Import LoadingSpinner
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { showModal } from 'Core/redux/main/slice';
import { Edit, Trash2 } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { deleteInspectionResults, fetchInspectionResultsData } from './store/slice';
import { actions as inspectionResultsActions } from './store/slice';
import { format } from 'date-fns';

const { INSPECTIONRESULTS_ADD_EDIT } = MODAL_TYPES;
const { setSelectedPart, clearDeepLink } = inspectionResultsActions;
const InspectionResultsTile = props => {
  console.log('in inspection tiles ===>');
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const inventoryTileRef = useRef(null);
  const filteredInspectionResultss = useSelector(selectFilteredInspectionResultss);
  console.log(filteredInspectionResultss);
  const isLoading = useSelector(selectInspectionResultsLoading);
  const filterVisible = useSelector(selectInspectionResultsFilterVisible);
  const headerVisible = useSelector(isHeaderVisible);

  const updateColumnSettings = useCallback(() => {
    if (inventoryTileRef.current) {
      const width = inventoryTileRef.current.offsetWidth;
      let columns = 6;

      if (width < 576) {
        columns = 1; // Mobile
      } else if (width < 768) {
        columns = 3; // Tablets
      } else if (width < 992) {
        columns = 5; // Large screens
      } else {
        columns = 6; // Extra large screens
      }

      setColumnCount(columns);
      setColumnWidth(width / columns);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);

  const itemData = filteredInspectionResultss.map(inspectionResults => (
    <Tile inspectionResults={inspectionResults} />
  ));

  return (
    <div
      className={`shipment-tile-body ${filterVisible ? 'filter-visible' : ''} ${
        !headerVisible ? 'header-collapsed' : ''
      }`}
      ref={inventoryTileRef}
    >
      {isLoading && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={Math.ceil(filteredInspectionResultss.length / columnCount)}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={150} // Adjusted row height
        />
      }
    </div>
  );
};

const Tile = ({ inspectionResults }) => {
  console.log('InspectionResults itemData', inspectionResults);
  const dispatch = useDispatch();

  const handleEdit = e => {
    e.stopPropagation();
    dispatch(clearDeepLink());
    dispatch(fetchInspectionResultsData({ 
      inspectionresults: inspectionResults, 
      pageNumber: 1, 
      pageSize: 10 
    }));
    dispatch(setSelectedPart(inspectionResults));
  };

  return (
    <div key={inspectionResults.inspectionResultsId || Math.random()} className="shipment-tile">
      <div
        className={`card p-3 m-2 ${inspectionResults.isNewlyCreated ? 'border-success' : ''}`}
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="tile-actions">
          <ButtonGroup size="sm">
            <Button variant="light" onClick={handleEdit}>
              <Edit size={16} />
            </Button>
          </ButtonGroup>
        </div>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <div className="c-details">
              <h6 className="mb-0">{inspectionResults.partNumber} </h6>
              {inspectionResults.inspectionDate && (
                <div className="mt-1">
                  <small style={{ fontSize: '0.7rem', color: '#6c757d', fontWeight: 'normal' }}>
                    {format(new Date(inspectionResults.inspectionDate), 'dd-MMM-yyyy HH:mm')}
                  </small>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="mt-1 d-flex align-items-center gap-2 mb-2">
          <span
            className="badge"
            style={{
              backgroundColor: '#ffe7c7',
              color: '#8a4b0f',
              fontWeight: 600,
            }}
          >
            Scrap Rate
          </span>
          {inspectionResults.noOfRequests !== undefined && inspectionResults.noOfRequests !== null && (
            <span
              className="badge"
              style={{
                backgroundColor:
                  inspectionResults.noOfRequestsLast12Hrs === 0 ? '#d9534f' : '#957cf9',
                color: inspectionResults.noOfRequestsLast12Hrs === 0 ? '#ffffff' : '#000000',
              }}
            >
              Inspections: {inspectionResults.noOfRequests}
            </span>
          )}
        </div>
        <div className="mt-2 tile-descriptionText text-truncate w-85">
          <span className="tile-description" style={{ fontSize: '0.8rem', lineHeight: '1.4' }}>
            {inspectionResults.description}
          </span>
        </div>
      </div>
    </div>
  );
};

export default InspectionResultsTile;
